import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import salesLogo from '../../../images/sales-stream/sales-stream.svg';

const useStyles = makeStyles({
  header: {
    padding: '0px 15px',
    color: '#FFFFFF',
  },
  logo: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '14px',
  },
  middleText: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
});

const SalesStreamHeader = () => {
  const classes = useStyles();
  return (
    <div className={classes.header}>
      <Grid container alignItems="center">
        <Grid item xs={3} className={classes.logo}>
          <img src={salesLogo} alt="Logo" style={{ height: '35px' }} />
        </Grid>
      </Grid>
    </div>
  );
};

export default SalesStreamHeader;
